const SCALED = ['gwp', 'water', 'pollution', 'cost'];
const NUM = {gwp:'kg CO₂-eq',water:'L',pollution:'Points',cost:'INR'};
export function basisUnit(parameter, reference, material=false) {
  return SCALED.includes(parameter) ? `${NUM[parameter]} / ${material ? 'kg material' : 'product'}` : null;
}
export default function ReferenceBasis({material=false}) {
  return <div className="border rounded bg-[#f2f7f4] p-4 mb-4">
    <p className="text-sm font-medium">Benchmark basis: Per 1 kg of {material ? 'material' : 'product'}</p>
    <p className="text-xs mt-2">Enter GWP, water, pollution and cost per kg. Convert source values per product by dividing by the source product weight in kg before entry. Percentages, scores and durations keep their own units.</p>
  </div>;
}
